import { render, staticRenderFns } from "./ForumPublish.vue?vue&type=template&id=797a1822&scoped=true&"
import script from "./ForumPublish.vue?vue&type=script&lang=js&"
export * from "./ForumPublish.vue?vue&type=script&lang=js&"
import style0 from "./ForumPublish.vue?vue&type=style&index=0&id=797a1822&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797a1822",
  null
  
)

export default component.exports